// src/components/Admin/AdminSidebar.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import {
  Building2,
  Globe,
  HelpCircle,
  LayoutDashboard,
  Menu,
  X,
} from "lucide-react";

const navItems = [
  {
    to: "/admin",
    label: "Clients",
    icon: Building2,
    end: true, // exact match only
  },
  {
    to: "/admin/geography",
    label: "Geography Library",
    icon: Globe,
  },
  {
    to: "/admin/faq",
    label: "FAQ Manager",
    icon: HelpCircle,
  },
];

const AdminSidebar = ({ mobileOpen, onMobileClose }) => {
  const navLinkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive
        ? "bg-white/15 text-white"
        : "text-gray-300 hover:bg-white/10 hover:text-white"
    }`;

  const sidebarContent = (
    <>
      {/* Brand */}
      <div className="px-4 py-5 border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center">
            <LayoutDashboard size={16} className="text-white" />
          </div>
          <div>
            <h2 className="text-white font-semibold text-sm leading-tight">
              HeatMap HQ
            </h2>
            <p className="text-gray-400 text-xs">Admin Console</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={navLinkClasses}
            onClick={onMobileClose}
          >
            <item.icon size={18} className="flex-shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-white/10">
        <p className="text-xs text-gray-500">v2.0 — Admin Dashboard</p>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop sidebar — always visible at lg+ */}
      <aside className="hidden lg:flex lg:flex-col lg:w-56 bg-primary flex-shrink-0">
        {sidebarContent}
      </aside>

      {/* Mobile sidebar — overlay with slide transition */}
      <div
        className={`fixed inset-0 z-50 lg:hidden transition-opacity duration-300 ${
          mobileOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black/50" onClick={onMobileClose} />

        {/* Sidebar panel */}
        <aside
          className={`fixed inset-y-0 left-0 w-64 bg-primary flex flex-col shadow-xl transition-transform duration-300 ease-out ${
            mobileOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {/* Close button */}
          <button
            onClick={onMobileClose}
            className="absolute top-4 right-3 text-gray-400 hover:text-white"
          >
            <X size={20} />
          </button>
          {sidebarContent}
        </aside>
      </div>
    </>
  );
};

export default AdminSidebar;
